import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
require('flatpickr/dist/flatpickr.min.css')
if(document.querySelector('.input-date-group')) {
    const dateGroups = document.querySelectorAll('.input-date-group')
    dateGroups.forEach(dateGroup => {
        const inputDate = dateGroup.querySelector('input[type=text]')
        const result = dateGroup.querySelector('input.result')
        let fechas
        flatpickr(inputDate, {
            "locale": "es",
            dateFormat: "d/m/Y",
            maxDate: "31.12.2020",
            onChange: function (selectedDates, dateStr, instance) {
                selectedDates.forEach(function (date) {
                    fechas = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
                    console.log(fechas)
                    result.value = fechas
                    // flatpickr(inputhasta, {
                    //     "locale": "es",
                    //     dateFormat: "d/m/Y",
                    //     minDate: fechaDesde,
                    //     maxDate: "31.12.2020",
                    // })
                  })
            }       
        })
    });
}